export default "__VITE_PUBLIC_ASSET__05214dbb__"